<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>
<div class="col-12" *ngIf="!isLoading">
  <div class="card" reflow="true">
    <h5 [ngStyle]="{ color: 'rgb(125, 22, 22)', 'font-weight': 'bold' }">
      {{ "VENDORS_DETAILS" | translate }}
    </h5>
    <form [formGroup]="farmersDetailsForm">
      <div class="p-fluid p-formgrid grid">
        <div class="field col-12 md:col-4">
          <label htmlFor="vendorType">{{ "VENDOR_TYPE" | translate }}</label>
          <p-dropdown
            [options]="vendorTypes"
            formControlName="vendorType"
            placeholder="Select Vendor Type"
          >
          </p-dropdown>
          <div
            *ngIf="isSubmitted && farmersFormControls.vendorType.errors"
            class="invalid-feedback"
          >
            <div *ngIf="farmersFormControls.vendorType.errors.required">
              {{ "VENDOR_TYPE_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>

        <div
          class="field col-12 md:col-4"
          *ngIf="selectedVendorType === 'vendor'"
        >
          <label htmlFor="vendorName">{{ "VENDOR_NAME" | translate }}</label>
          <input
            formControlName="vendorsName"
            pInputText
            id="vendorName"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                farmersDetailsForm.controls['vendorsName'].invalid &&
                farmersDetailsForm.controls['vendorsName'].touched
            }"
          />
          <div
            *ngIf="
              farmersDetailsForm.controls['vendorsName'].invalid &&
              farmersDetailsForm.controls['vendorsName'].touched
            "
            class="invalid-feedback"
          >
            <div
              *ngIf="farmersDetailsForm.controls['vendorsName'].errors.required"
            >
              {{ "VENDOR_NAME_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{ "MOBILE" | translate }}</label>
          <div>
            <span style="font-weight: bold">{{
              farmersDetailsForm.controls.mobileNo.value
            }}</span>
          </div>

          <div
            *ngIf="isSubmitted && farmersFormControls.mobileNo.errors"
            class="invalid-feedback"
          >
            <div *ngIf="farmersFormControls.mobileNo.errors.required">
              {{ "MOBILE_NO_IS_REQUIRED" | translate }}
            </div>

            <div *ngIf="farmersFormControls.mobileNo.errors.minlength">
              {{ "MOBILE_NO_SHOULD_BE_OF_10_DIGITS" | translate }}
            </div>
            <div *ngIf="farmersFormControls.mobileNo.errors.maxlength">
              {{ "MOBILE_NO_SHOULD_BE_OF_10_DIGITS" | translate }}
            </div>
            <div *ngIf="farmersFormControls.mobileNo.errors.pattern">
              {{ "MBILE_NO_SHOULD_CONTAIN" | translate }}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="accountNumber">{{
            "ACCOUNT_NUMBER" | translate
          }}</label>
          <input
            formControlName="accountNumber"
            pInputText
            id="accountNumber"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                farmersDetailsForm.controls['accountNumber'].invalid &&
                farmersDetailsForm.controls['accountNumber'].touched
            }"
          />
          <div
            *ngIf="
              farmersDetailsForm.controls['accountNumber'].invalid &&
              farmersDetailsForm.controls['accountNumber'].touched
            "
            class="invalid-feedback"
          >
            <div
              *ngIf="
                farmersDetailsForm.controls['accountNumber'].errors.required
              "
            >
              {{ "ACCOUNT_NUMBER_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="inventoryStatus">{{ "BANK_NAME" | translate }}</label>
          <p-autoComplete
            [(ngModel)]="bankAccount.bankName"
            placeholder="select name of bank"
            id="dd"
            [dropdown]="true"
            [multiple]="false"
            appendTo="body"
            formControlName="bankName"
            [suggestions]="filteredBankList"
            (completeMethod)="filterBank($event)"
            field="Bank_NAME"
            value="BANK_ID"
          ></p-autoComplete>
        </div>
        <div class="field col-12 md:col-4">
          <label for="inventoryStatus">{{ "IFSC_CODE" | translate }}</label>
          <input
            type="text"
            formControlName="ifscCode"
            pInputText
            id="fatherName"
            required
            autofocus
          />
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{ "DATE_OF_BIRTH" | translate }}</label>
          <p-calendar
            [maxDate]="todayDate"
            [showIcon]="true"
            [showButtonBar]="true"
            dateFormat="dd-mm-yy"
            formControlName="dob"
            [ngClass]="{
              'ng-invalid ng-dirty':
                farmersDetailsForm.controls['dob'].invalid &&
                farmersDetailsForm.controls['dob'].touched
            }"
          ></p-calendar>
          <div
            *ngIf="
              farmersDetailsForm.controls['dob'].invalid &&
              farmersDetailsForm.controls['dob'].touched
            "
            class="invalid-feedback"
          >
            <div *ngIf="farmersDetailsForm.controls['dob'].errors.required">
              {{ "DATE_OF_BIRTH_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{ "EMAIL_ID" | translate }}</label>
          <input
            formControlName="emailId"
            pInputText
            id="fatherName"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                farmersDetailsForm.controls['emailId'].invalid &&
                farmersDetailsForm.controls['emailId'].touched
            }"
          />
          <div
            *ngIf="
              farmersDetailsForm.controls['emailId'].invalid &&
              farmersDetailsForm.controls['emailId'].touched
            "
            class="invalid-feedback"
          >
            <div *ngIf="farmersDetailsForm.controls['emailId'].errors.required">
              {{ "EMAIL_ID_IS_REQUIRED" | translate }}
            </div>
            <div *ngIf="farmersDetailsForm.controls['emailId'].errors.email">
              {{ "EMAIL_IS_INVALID" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{ "BIS_PAPER" | translate }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'bIS_Certificate_path', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.bIS_Certificate_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.bIS_Certificate_path.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{ "PAN_NUMBER" | translate }}</label>
          <input
            maxlength="10"
            formControlName="panNumber"
            pInputText
            id="block"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                farmersDetailsForm.controls['panNumber'].invalid &&
                farmersDetailsForm.controls['panNumber'].touched
            }"
          />
          <div
            *ngIf="
              farmersDetailsForm.controls['panNumber'].invalid &&
              farmersDetailsForm.controls['panNumber'].touched
            "
            class="invalid-feedback"
          >
            <div
              *ngIf="farmersDetailsForm.controls['panNumber'].errors.required"
            >
              {{ "PAN_NO_IS_REQUIRED" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['panNumber'].errors.minlength"
            >
              {{ "PAN_NO_IS_SHOULD_BE_OF_10_DIGITS" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['panNumber'].errors.maxlength"
            >
              {{ "PAN_NO_IS_SHOULD_BE_OF_10_DIGITS" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['panNumber'].errors.pattern"
            >
              {{ "INVALID_PAN_NO" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{ "PAN_PHOTO" | translate }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="onUpload($event, 'pAN_path', farmerLandLocUpload)"
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.pAN_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.pAN_path.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "EXPERIENCE_CERTIFICATE" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'exp_Certificate', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.exp_Certificate.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.exp_Certificate.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{ "AADHAR_NUMBER" | translate }}</label>
          <input
            maxlength="12"
            formControlName="aadhaar_No"
            pInputText
            id="block"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                farmersDetailsForm.controls['aadhaar_No'].invalid &&
                farmersDetailsForm.controls['aadhaar_No'].touched
            }"
          />
          <div
            *ngIf="
              farmersDetailsForm.controls['aadhaar_No'].invalid &&
              farmersDetailsForm.controls['aadhaar_No'].touched
            "
            class="invalid-feedback"
          >
            <div
              *ngIf="farmersDetailsForm.controls['aadhaar_No'].errors.required"
            >
              {{ "AADHAR_NO_IS_REQUIRED" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['aadhaar_No'].errors.minlength"
            >
              {{ "AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['aadhaar_No'].errors.maxlength"
            >
              {{ "AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['aadhaar_No'].errors.pattern"
            >
              {{ "AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "AADHAR_PHOTO" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'aadhaar_path', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.aadhaar_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.aadhaar_path.errors.required">
              {{ "AADHAR_PHOTO_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>
        
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "UNDERTAKINGS" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'undertaking_path', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.undertaking_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.undertaking_path.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "BANK_GUARANTEE_DRAFT" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'bank_Gurantee', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.bank_Gurantee.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.bank_Gurantee.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "DEMAND_DRAFT_PATH" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'demand_Draft_path', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.demand_Draft_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.demand_Draft_path.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="vendorName">{{ "GST_NUMBER" | translate }}</label>
          <input
            formControlName="gstNumber"
            pInputText
            id="gstNumber"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                farmersDetailsForm.controls['gstNumber'].invalid &&
                farmersDetailsForm.controls['gstNumber'].touched
            }"
          />
          <div
            *ngIf="
              farmersDetailsForm.controls['gstNumber'].invalid &&
              farmersDetailsForm.controls['gstNumber'].touched
            "
            class="invalid-feedback"
          >
            <div
              *ngIf="farmersDetailsForm.controls['gstNumber'].errors.required"
            >
              {{ "GST_NUMBER_IS_REQUIRED" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['gstNumber'].errors.minlength"
            >
              {{ "GST_NO_IS_SHOULD_BE_OF_15_DIGITS" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['gstNumber'].errors.maxlength"
            >
              {{ "GST_NO_IS_SHOULD_BE_OF_15_DIGITS" | translate }}
            </div>
            <div
              *ngIf="farmersDetailsForm.controls['gstNumber'].errors.pattern"
            >
              {{ "INVALID_GST_NO" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "GST_CERTIFICATE" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'gST_Certificate_path', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.gST_Certificate_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.gST_Certificate_path.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "TRADEMARK_DOCUMENT" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'tradeMark_Doc', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.tradeMark_Doc.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.tradeMark_Doc.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "REGISTRATION_CERTIFICATE" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload(
                $event,
                'registration_Certificate_path',
                farmerLandLocUpload
              )
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.registration_Certificate_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.registration_Certificate_path.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{
            "PREDISPATCH_REPORT" | translate
          }}</label>
          <p-fileUpload
            accept=".jpeg,.pdf,.jpg"
            [customUpload]="true"
            #farmerLandLocUpload
            (uploadHandler)="
              onUpload($event, 'predispatch_Report_path', farmerLandLocUpload)
            "
            name="myfile[]"
            [maxFileSize]="5000000"
            [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}"
            [auto]="false"
            [showCancelButton]="false"
          >
          </p-fileUpload>
          <div
            *ngIf="isSubmitted && f.predispatch_Report_path.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.predispatch_Report_path.errors.required">
              {{ "CHOOSE_AND_UPLOAD_LAND_DOCUMENT" | translate }}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{ "ADDRESS" | translate }}</label>
          <input
            formControlName="address"
            pInputText
            id="fatherName"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                isSubmitted && farmersFormControls.address.errors
            }"
          />

          <div
            *ngIf="isSubmitted && farmersFormControls.address.errors"
            class="invalid-feedback"
          >
            <div *ngIf="farmersFormControls.address.errors.required">
              {{ "ADDRESS_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="villageCode">{{ "VILLAGE" | translate }}</label>
          <p-autoComplete
            formControlName="village"
            [(ngModel)]="selectedVillage"
            placeholder="Search"
            id="dd"
            [dropdown]="true"
            [multiple]="false"
            [suggestions]="filteredVillage"
            (completeMethod)="filterVillage($event)"
            field="Name"
            value="Code"
            [ngClass]="{
              'ng-invalid ng-dirty':
                isSubmitted && farmersFormControls.village.errors
            }"
          ></p-autoComplete>

          <div
            *ngIf="isSubmitted && farmersFormControls.village.errors"
            class="invalid-feedback"
          >
            <div *ngIf="farmersFormControls.village.errors.required">
              {{ "VILLAGE_NAME_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="pinCode">{{ "PINCODE" | translate }}</label>
          <input
            maxlength="6"
            pattern="^[0-9]{6}$"
            pKeyFilter="int"
            formControlName="pincode"
            pInputText
            id="pinCode"
            type="text"
            [ngClass]="{
              'ng-invalid ng-dirty':
                isSubmitted && farmersFormControls.pincode.errors
            }"
          />

          <div
            *ngIf="isSubmitted && farmersFormControls.pincode.errors"
            class="invalid-feedback"
          >
            <div *ngIf="farmersFormControls.pincode.errors.required">
              {{ "PINCODE_IS_REQUIRED" | translate }}
            </div>
          </div>
        </div>
      </div>
    </form>
    <div *ngIf="!(isEditable == 0)">
      <button
        (click)="onFarmersFormSubmit()"
        pButton
        pRipple
        type="button"
        label="{{ 'SAVE' | translate }}"
        class="p-button-success mr-2 mb-2"
      ></button>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showAadharVerDialog"
  [style]="{ width: '550px' }"
  header="{{ 'VERIFY_AADHAR_NUMBER' | translate }}"
  [modal]="true"
  [baseZIndex]="-100"
  styleClass="p-fluid"
  (onHide)="hideDialog()"
>
  <ng-template pTemplate="content">
    <div
      class="p-fluid p-formgrid justify-content-center ver-dialog mt-2 outer-div"
      style="display: flex; flex-wrap: wrap"
    >
      <img
        src="../../../../assets/aadhar/aadhar1.jpeg"
        alt="bg"
        style="width: 100%"
      />
      <div class="inner-div">
        <div class="field md:col-12 col-12 aadhar-number">
          <label [style]="{ color: 'rgb(3, 2, 2)' }"
            >{{ "AADHAR_NUMBER" | translate }}:
            <label class="px-2" [style]="{ color: 'rgb(148, 9, 9)' }">{{
              aadharNumber
            }}</label></label
          >
        </div>

        <div class="field md:col-12 col-12 edit-aadhar">
          <a
            class="d-flex flex-row-reverse"
            (click)="editAadharNumber()"
            style="cursor: pointer"
            >{{ "CLICK_HERE_TO_EDIT_AADHAR_NUMBER" | translate }}</a
          >
        </div>

        <!-- <div class="field md:col-12 col-12 otp-field">
          <label [style]="{ color: 'rgb(3, 2, 2)' }"
            >{{ "ENTER_OTP" | translate }}:
          </label>
          <input
            pInputText
            maxlength="6"
            [(ngModel)]="aadharVerOTP"
            placeholder="OTP"
            type="number"
          />
        </div> -->

        <div class="field md:col-12 col-12 resendOTP">
          <div class="timer resendOTP" *ngIf="timer > 0">
            Resend OTP in: {{ timer }} Seconds
          </div>
          <a *ngIf="timer === 0" (click)="resendOTP()" style="cursor: pointer"
            >Resend OTP</a
          >
        </div>

        <div class="field md:col-12 col-12">
          <button
            pButton
            pRipple
            label="{{ 'SUBMIT_OTP' | translate }}"
            class="p-button-success"
            (click)="submitOTP()"
          ></button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="{{ 'CANCEL' | translate }}"
      icon="pi pi-times"
      class="p-button-text"
      (click)="hideDialog()"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="openPPIDDialog"
  [style]="{ width: '900px' }"
  header="{{ 'PPP ID Deatils' | translate }}"
  [modal]="true"
  [baseZIndex]="-100"
  styleClass="p-fluid"
  (onHide)="hidePPIDDialog()"
>
  <ng-template pTemplate="content">
    <div
      *ngIf="showPPPIdValidationBox"
      class="p-fluid p-formgrid justify-content-center ver-dialog mt-2 outer-div"
      style="display: flex; flex-wrap: wrap"
    >
      <div>
        <div class="field md:col-12 col-12 otp-field">
          <label [style]="{ color: 'rgb(3, 2, 2)' }"
            >{{ "Member ID" | translate }}:
          </label>
          <input
            readonly
            pInputText
            maxlength="8"
            [(ngModel)]="fetchedMemberId"
            placeholder="PPP ID"
            type="text"
          />
        </div>
        <div>
          <div class="field md:col-12 col-12 otp-field">
            <label [style]="{ color: 'rgb(3, 2, 2)' }"
              >{{ "Enter OTP" | translate }}:
            </label>
            <input
              pInputText
              maxlength="6"
              [(ngModel)]="memberIdOTPValue"
              placeholder="OTP"
              type="number"
            />
          </div>

          <div class="field md:col-12 col-12">
            <button
              pButton
              pRipple
              label="{{ 'SUBMIT_OTP' | translate }}"
              class="p-button-success"
              (click)="onSubmitMemIdOTP()"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="{{ 'CANCEL' | translate }}"
      icon="pi pi-times"
      class="p-button-text"
      (click)="hidePPIDDialog()"
    ></button>
  </ng-template>
</p-dialog>
